// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid {
  grid-template-columns: repeat(2, auto);
}
.client-select-list {
  height: 300px !important;
  overflow-y: scroll;
}
h2.filter-title {
  width: 100%;
  display: block;
  text-align: center;
  background: #bfc3ce;
}
.disabled {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/app/pms-management/dialogs/mapping-management/mapping-management.component.less"],"names":[],"mappings":"AAIA;EACI,sCAAA;AAHJ;AAOA;EACI,wBAAA;EACA,kBAAA;AALJ;AAQA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AANJ;AASA;EACI,UAAA;AAPJ","sourcesContent":["@import (reference) url('../../../../styles.less');\n@import (reference) url('../../../../assets/ngb-modals.less');\n\n\n.grid {\n    grid-template-columns: repeat(2, auto);\n\n}\n\n.client-select-list {\n    height: 300px !important;\n    overflow-y: scroll;\n}\n\nh2.filter-title{\n    width:100%;\n    display:block;\n    text-align: center;\n    background: #bfc3ce;\n}\n\n.disabled{\n    color:red;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
